import { findNearestElement, isElement } from '../dom/node';

export function getComputedStyle(node: Node, container: Node): CSSStyleDeclaration | null {
  const window = node.ownerDocument && node.ownerDocument.defaultView;
  if (!window) {
    return null;
  }

  const element = findNearestElement(node, container);
  if (!element) {
    return null;
  }

  return window.getComputedStyle(element);
}

export function getCascadingComputedStyle(node: Node, container: Node): CSSStyleDeclaration[] {
  const window = node.ownerDocument && node.ownerDocument.defaultView;
  if (!window) {
    return [];
  }

  const computedStyles: CSSStyleDeclaration[] = [];

  let parentNode: Node | null = node;
  while (parentNode) {
    if (isElement(parentNode)) {
      computedStyles.push(window.getComputedStyle(parentNode));
    }

    parentNode = parentNode !== container ? parentNode.parentNode : null;
  }

  return computedStyles;
}
